(function () {
  'use strict';

  var resizeTimer = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function removeLoopClones(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('.swiper-slide[data-cc-loop-clone="true"]').forEach(function (el) {
      el.remove();
    });
  }

  function syncToggleLabel(wrap, button, expanded) {
    var moreLabel = button.getAttribute('data-label-more') || 'Read more';
    var lessLabel = button.getAttribute('data-label-less') || 'Read less';
    button.textContent = expanded ? lessLabel : moreLabel;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function resetTextToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-text-toggle]').forEach(function (wrap) {
      var button = wrap.querySelector('.cc-testimonials__text-toggle');
      if (!button) return;
      wrap.setAttribute('data-expanded', 'false');
      syncToggleLabel(wrap, button, false);
    });
  }

  function updateTextToggle(wrap) {
    var body = wrap.querySelector('.cc-testimonials__text-body');
    var button = wrap.querySelector('.cc-testimonials__text-toggle');
    if (!body || !button) return;

    var wasExpanded = wrap.getAttribute('data-expanded') === 'true';

    wrap.setAttribute('data-expanded', 'false');
    void body.offsetHeight;

    var overflows = body.scrollHeight > body.clientHeight + 1;

    if (!overflows) {
      wrap.setAttribute('data-expanded', 'false');
      button.hidden = true;
      syncToggleLabel(wrap, button, false);
      return;
    }

    button.hidden = false;
    wrap.setAttribute('data-expanded', wasExpanded ? 'true' : 'false');
    syncToggleLabel(wrap, button, wasExpanded);
  }

  function initTextToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-text-toggle]').forEach(updateTextToggle);
  }

  function refreshSwiperHeight(wrap) {
    var swiperEl = wrap.closest('.cc-testimonials-swiper');
    if (swiperEl && swiperEl.swiper && typeof swiperEl.swiper.update === 'function') {
      swiperEl.swiper.update();
    }
  }

  function getHeaderOffset() {
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      return stickyHeader.offsetHeight || 0;
    }
    var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var parsed = parseFloat(headerHeight);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function maybeScrollSectionToTop(sectionEl) {
    if (!sectionEl) return;

    var headerOffset = getHeaderOffset();
    var rect = sectionEl.getBoundingClientRect();
    var hiddenFromTop = headerOffset - rect.top;

    if (hiddenFromTop <= 400) return;

    var targetTop = window.scrollY + rect.top - headerOffset;
    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function initTestimonialsSlider(sectionEl) {
    if (!sectionEl || typeof window.Swiper === 'undefined') return;

    var swiperEl = sectionEl.querySelector('.cc-testimonials-swiper');
    if (!swiperEl) return;

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    // Strip any old manual clones from previous inits
    removeLoopClones(wrapper);

    var slideCount = wrapper.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    var prevButton = sectionEl.querySelector('.cc-testimonials__nav-btn--prev');
    var nextButton = sectionEl.querySelector('.cc-testimonials__nav-btn--next');
    var reducedMotion = prefersReducedMotion();

    // Desktop peeks ~1.87 slides. True `loop` clones slides into the track —
    // with few unique cards that puts the same person (e.g. Amy) as both
    // center and side peek. Only enable loop when there are enough UNIQUE
    // slides that prev / active / next can all be different.
    // Otherwise use `rewind` so next/prev still wrap, without duplicate slides.
    var minUniqueForLoop = 4;
    var useLoop = slideCount >= minUniqueForLoop;
    var useRewind = !useLoop && slideCount >= 2;

    new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: useLoop,
      rewind: useRewind,
      watchOverflow: true,
      speed: reducedMotion ? 0 : 400,
      grabCursor: true,
      navigation:
        prevButton && nextButton
          ? {
              nextEl: nextButton,
              prevEl: prevButton
            }
          : false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: true
        },
        990: {
          slidesPerView: 1.87,
          spaceBetween: 30,
          centeredSlides: true
        }
      },
      on: {
        init: function () {
          initTextToggles(sectionEl);
        },
        resize: function () {
          initTextToggles(sectionEl);
        },
        slideChangeTransitionStart: function () {
          resetTextToggles(sectionEl);
          this.update();
          maybeScrollSectionToTop(sectionEl);
        }
      }
    });

    initTextToggles(sectionEl);
  }

  function whenSwiperReady(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  }

  function initAll() {
    whenSwiperReady(function () {
      document.querySelectorAll('[data-cc-testimonials]').forEach(function (sectionEl) {
        initTestimonialsSlider(sectionEl);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cc-testimonials__text-toggle');
    if (!button) return;

    var wrap = button.closest('[data-cc-text-toggle]');
    if (!wrap) return;

    event.preventDefault();
    var expanded = wrap.getAttribute('data-expanded') === 'true';
    wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
    syncToggleLabel(wrap, button, !expanded);
    refreshSwiperHeight(wrap);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initTextToggles(document);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.detail && event.detail.container ? event.detail.container : event.target;
    var section = container.querySelector
      ? container.querySelector('[data-cc-testimonials]')
      : null;
    if (!section && container && container.hasAttribute && container.hasAttribute('data-cc-testimonials')) {
      section = container;
    }
    if (section) {
      whenSwiperReady(function () {
        initTestimonialsSlider(section);
      });
    }
  });

  document.addEventListener('shopify:section:reorder', initAll);
})();
